import isRenderUnsubscribe from '../functions/isRenderUnsubscribe'
import { NewsletterSectionRow, TableWrapper } from './helpersComponents'
import { textNormal, textTiny } from './helpersTypo'
import NewsletterContentText from './NewsletterContentText'
import NewsletterTranslation from './NewsletterTranslation'

const NewsletterSectionUnsubscribe = ({stylesData, cinemaData, translation}) => {
    const chosenFont = stylesData.chosenFont
    const colorText = stylesData.secText

    const text = <NewsletterTranslation id="print_newsletter_preview_text_unsubscribe" translation={translation} after=" ">
        Wenn Sie keine E-Mails mehr von uns erhalten möchten, klicken Sie bitte</NewsletterTranslation>
    const button = <NewsletterTranslation id="print_newsletter_preview_button_unsubscribe" translation={translation}>
        hier</NewsletterTranslation>

    return (
        isRenderUnsubscribe(cinemaData) ? 
            <NewsletterSectionRow key="unsubscribe-section">
                <TableWrapper>
                    <tr key={'text'}>
                        <NewsletterContentText>
                            <p style={{...{color: colorText, textAlign: 'center', paddingTop: "11px", paddingBottom: "44px"}, ...textNormal(chosenFont)}}>
                                {text}<a 
                                style={{...{color: colorText}, ...textNormal(chosenFont)}}
                                href="{{params.UNSUBSCRIBE_LINK}}">{button}</a>
                            </p>
                        </NewsletterContentText>
                    </tr>
                </TableWrapper>
            </NewsletterSectionRow>
        : null
    )
}

export default NewsletterSectionUnsubscribe